import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'view-image-button',
    templateUrl: './view-image-button.component.html',
    styleUrls: ['./view-image-button.component.scss'],
    standalone: true
})
export class ViewImageButtonTableComponent implements OnInit {
    @Input() url: string;
    @Output() viewEvent = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    viewRoute() {
        this.viewEvent.emit(this.url);
    }

}
